<script>
    import { trainerTexts as texts } from './trainerTexts.js';
    export let lang = 'eng';
</script>

<header class="header">
    <div class="header_box">
        <h1 class="heading-primary">{texts[lang].header_primary}</h1>
        <h2 class="heading-secondary">{texts[lang].header_secondary}</h2>
    </div>
    <div class="header_logo" />
</header>
